import { post } from "@api/httpClient";

export type ApplicantScreenshotEventPayload = {
  millisBeforeDeadline: number;
  pressedKeys: string[];
  activityId: string;
};

interface ApplicantScreenshotEventParams {
  applicantExamId: number;
  challengeResultId: number;
  payload: ApplicantScreenshotEventPayload;
}
export async function postScreenshotEvent({
  applicantExamId,
  challengeResultId,
  payload,
}: ApplicantScreenshotEventParams) {
  const { data } = await post(
    `/api/applicants/exams/${applicantExamId}/results/${challengeResultId}/screenshot`,
    {
      data: payload,
    },
  );

  return data;
}
